import { Box, Link, Stack, Flex } from "@chakra-ui/react";
import YCLogo from "../assets/yc.webp";
import SOC2Badge from "../assets/security/SOC2.png";

export default function Footer() {
  return (
    <Box
      as="footer"
      py={4}
      width="100%"
      backgroundColor="#0d0a1a"
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        fontSize={"sm"}
        my={{ base: 4, md: 0 }}
        gap={4}
      >
        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={4}
          align="center"
          justify="center"
          textAlign="center"
        >
          <Flex align="center" gap={2} style={{ cursor: "pointer" }} onClick={() => window.open("https://sweep-1.safebase.us/", "_blank", "noopener,noreferrer")}>
            <img

              src={SOC2Badge}
              alt="SOC 2 Compliant"
              style={{ filter: "brightness(0.9)", height: "50px" }}
            />
            <span style={{ color: "#fff", textDecoration: "none" }} onMouseEnter={e => (e.currentTarget.style.textDecoration = "underline")} onMouseLeave={e => (e.currentTarget.style.textDecoration = "none")}>Trust Center</span>
          </Flex>
          <Link href="/privacy.pdf">
            Privacy
          </Link>
          <Link href="https://docs.sweep.dev/privacy">
            Zero Data Retention
          </Link>
          <Link
            href="https://techcrunch.com/2023/11/02/sweep-aims-to-automate-basic-dev-tasks-using-large-language-models/"
            target="_blank"
            rel="noopener noreferrer"
            display="inline-flex"
            alignItems="center"
          >
            Backed by{" "}
            <img
              src={YCLogo}
              alt="Y Combinator"
              style={{ marginLeft: "10px" }}
              height="10px"
            />
          </Link>
          <p className="transparentText">{new Date().getFullYear()} Sweep AI Inc. All rights reserved.</p>
        </Stack>
      </Flex>
    </Box>
  );
}
